/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type PreviewEquipmentBrowserViewRequestBody = {
  /**
   * Display template to preview
   */
  displayTemplate: string;
  /**
   * The id of the equipment browser view. If not specified, the default view will be returned.
   */
  viewId?: string | undefined;
};

/** @internal */
export type PreviewEquipmentBrowserViewRequestBody$Outbound = {
  display_template: string;
  view_id?: string | undefined;
};

/** @internal */
export const PreviewEquipmentBrowserViewRequestBody$outboundSchema: z.ZodType<
  PreviewEquipmentBrowserViewRequestBody$Outbound,
  z.ZodTypeDef,
  PreviewEquipmentBrowserViewRequestBody
> = z.object({
  displayTemplate: z.string(),
  viewId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    displayTemplate: "display_template",
    viewId: "view_id",
  });
});

export function previewEquipmentBrowserViewRequestBodyToJSON(
  previewEquipmentBrowserViewRequestBody:
    PreviewEquipmentBrowserViewRequestBody,
): string {
  return JSON.stringify(
    PreviewEquipmentBrowserViewRequestBody$outboundSchema.parse(
      previewEquipmentBrowserViewRequestBody,
    ),
  );
}
